/** 二年级上册：源目录按 Unit 分类，资源键独立于原文件大小写和空格。 */
export const textbookUnits = Array.from({ length: 6 }, (_, index) => {
  const unit = index + 1;
  const phonics = unit === 2 || unit === 5 ? "letters" : "sound";
  return {
    unit,
    tracks: ["ready", "words", "communicate", "story", phonics, "extend"].map(section => ({
      section,
      label: ({ ready: "Ready", words: "Words", communicate: "Communicate", story: "Story", letters: "Letters", sound: "Sound", extend: "Extend" } as Record<string, string>)[section],
      key: `2a/unit${unit}/${section}.mp3`,
    })),
    videos: ["ready", "story", "extend", "sounds", "words"].map((section, offset) => ({
      section,
      label: ["课文", "Story", "Extend", "Sounds / Letters", "单词"][offset],
      key: `2a/unit${unit}/video/${section}.mp4`,
    })),
  };
});

export function isTextbookMediaKey(key: string): boolean {
  return textbookUnits.some(unit => [...unit.tracks, ...unit.videos].some(track => track.key === key));
}
